export default __webpack_public_path__ + "c6798fe9aaf79299d2f736e179e9752b.webp";